var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5757 9.57573C7.81002 9.81005 8.18992 9.81005 8.42423 9.57574L10.9757 7.02427C11.3537 6.64629 11.086 6 10.5515 6H5.44852C4.91398 6 4.64628 6.64628 5.02425 7.02426L7.5757 9.57573Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownMonth);
export default __webpack_public_path__ + "static/media/arrow-down-month.6c206455f69519ff8ec4f5cd9a439182.svg";
export { ForwardRef as ReactComponent };